import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SpreadsheetDashboardNotificationCardModel } from './spreadsheet-dashboard-notification-card.model';
import { JobNotificationCardComponent } from '../job-notification-card.component';
import { PrintActionButtonsComponent } from '../../../action-buttons/print-action-buttons/print-action-buttons.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-spreadsheet-dashboard-notification-card',
  templateUrl: './spreadsheet-dashboard-notification-card.component.html',
  styleUrls: ['./spreadsheet-dashboard-notification-card.component.scss'],
  imports: [JobNotificationCardComponent, PrintActionButtonsComponent],
})
export class SpreadsheetDashboardNotificationCardComponent {
  @Output() public closeEvent = new EventEmitter<void>();
  @Output() public downloadSpreadsheetButtonEvent = new EventEmitter<void>();
  @Input() public spreadsheetDashboardNotificationCard: SpreadsheetDashboardNotificationCardModel;

  public downloadSpreadsheetButtonClickedHandler(): void {
    this.downloadSpreadsheetButtonEvent.emit();
  }

  public onCloseClickedHandler(): void {
    this.closeEvent.emit();
  }
}
